import { useMutation } from '@apollo/client'
import {
  REASSIGN_CHAT_CLINICIAN,
  ReassignChatClinicianResponse,
} from '../queries'

export const useReassignChat = () => {
  const [
    reassignChat,
    { loading, error },
  ] = useMutation<ReassignChatClinicianResponse>(REASSIGN_CHAT_CLINICIAN, {
    refetchQueries: ['GetChats'],
  })

  const reassign = async (chatIds: string[]) => {
    const result = await reassignChat({ variables: { chatIds } })
    return result.data?.reassignChatClinician ?? null
  }

  return {
    reassign,
    loading,
    error,
  }
}
